import { Route, Routes } from 'react-router-dom';
import DriveModule from '.';

const DriveRoute = () => {
  return (
    <Routes>
      <Route path="/:filterId" element={<DriveModule />} />
      <Route path="/*" element={<DriveModule />} />
    </Routes>
  );
};

export default DriveRoute;
